import { FETCH_VM_LIST, RESET_VM_LIST } from "../../constants/action.constants";
import { getAccessToken } from "../../services/browserStorage";
import { webApiCheck } from "../../services/commonMethods";
import { postDashboardWebApi } from "../../webApis/apiResource";

export const requestVMList = (urlEndPoint, payload) => {
  return async (dispatch) => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      urlEndPoint,
      payload
    );
    if (webApiCheck(response)) {
      dispatch(fetchVMList(response.data));
    }
  };
};

const fetchVMList = (resp) => {
  const { data, ...others } = resp;
  return {
    type: FETCH_VM_LIST,
    payload: data,
    others,
  };
};

export const resetVMList = () => {
  return {
    type: RESET_VM_LIST,
  };
};
